export const CTAMap = {
    RECEIVED: {},
    CONFIRMED: {},
    ALLOCATION_PENDING: {},
    ALLOCATION_IN_PROGRESS: {
        tabs: {
            READY_TO_DEPLOY: true,
        },
    },
    ALLOCATION_CLOSED: {
        tabs: {
            READY_TO_DEPLOY: true,
            DEPLOYMENT_COMPLETE: true,
        },
    },
    READY_TO_DEPLOY: {
        tabs: {
            READY_TO_DEPLOY: true,
            DEPLOYMENT_COMPLETE: true,
        },
    },
    DEPLOYED: {
        tabs: {
            DEPLOYMENT_COMPLETE: true,
        },
    },
}
